import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useTranslate } from 'react-admin';
import { EmptyState } from './EmptyState';

interface AccessDeniedProps {
  /** Overrides the default "auditor cannot write" copy — e.g. a `403 tenant_not_authorized`. */
  title?: string;
  body?: string;
}

/**
 * Shown for any `403` authorization boundary: a write action attempted by
 * `platform:auditor`, or a report/admin query rejected because a requested
 * tenant is outside the caller's authorized set. Never a bug to route
 * around client-side — never retried with a widened or dropped filter.
 */
export function AccessDenied({ title, body }: AccessDeniedProps = {}) {
  const translate = useTranslate();
  return (
    <EmptyState
      icon={<LockOutlinedIcon fontSize="inherit" />}
      title={title ?? translate('pay.accessDenied.title')}
      body={body ?? translate('pay.accessDenied.body')}
    />
  );
}
